// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 203) return "static/chunks/e3762d72-ee78ba5b245f9ffa.js";
	if (chunkId === 336) return "static/chunks/336-283c3d35eeb9e308.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"113cab9e1c3a51c8","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"e655b2ee41862929","367":"05696e7bf77c31fe","639":"01ed8ade82059ce8","748":"edff785100ecc5dc"}[chunkId] + ".js";
};